import React, { useState } from "react";
import "../Styles/GetInTouch.css";
import { IoReloadCircle } from "react-icons/io5";

/* ✅ IMPORT API */
import ApiService from "../nhrc_apis/ApiService";
const { ContactAPI } = ApiService;

function GetInTouch() {
  const [showPopup, setShowPopup] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
    captchaInput: "",
  });

  const [captcha, setCaptcha] = useState("1S7mT");
  const [loading, setLoading] = useState(false);

  const togglePopup = () => setShowPopup(!showPopup);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const generateCaptcha = () => {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ123456789";
    let newCaptcha = "";
    for (let i = 0; i < 5; i++) {
      newCaptcha += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCaptcha(newCaptcha);
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    /* ✅ CAPTCHA VALIDATION */
    if (formData.captchaInput !== captcha) {
      alert("Invalid Captcha");
      return;
    }

    try {
      setLoading(true);

      /* ✅ API PAYLOAD (MATCH BACKEND) */
      const payload = {
        name: formData.name,
        email: formData.email,
        mobile: formData.mobile,
        message: formData.message,
      };

      console.log("CONTACT PAYLOAD:", payload);

      /* ✅ API CALL */
      await ContactAPI.createContact(payload);

      alert("Message sent successfully");

      /* RESET FORM */
      setFormData({
        name: "",
        email: "",
        mobile: "",
        message: "",
        captchaInput: "",
      });

      generateCaptcha();
      setShowPopup(false);

    } catch (error) {
      console.error("CONTACT ERROR:", error);

      alert(
        error?.response?.data?.detail ||
        error?.response?.data?.message ||
        "❌ Failed to send message"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button className="git-btn" onClick={togglePopup}>
        Get in Touch
      </button>

      {showPopup && (
        <div className="git-overlay" onClick={togglePopup}>
          <div
            className="git-popup"
            onClick={(e) => e.stopPropagation()}
          >
            <span className="git-close" onClick={togglePopup}>
              &times;
            </span>

            <h2 className="git-title">Get in Touch</h2>

            <form className="git-form" id="getinform" onSubmit={handleSubmit}>
              <label>Name:</label>
              <input
                type="text"
                name="name"
                placeholder="Enter your name"
                required
                value={formData.name}
                onChange={handleChange}
              />

              <label>Email:</label>
              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                required
                value={formData.email}
                onChange={handleChange}
              />

              <label>Mobile:</label>
              <input
                type="text"
                name="mobile"
                placeholder="Enter your phone number"
                required
                value={formData.mobile}
                onChange={handleChange}
              />

              <label>Message:</label>
              <textarea
                name="message"
                placeholder="Your message"
                rows="4"
                value={formData.message}
                onChange={handleChange}
              ></textarea>

              <div className="captcha-section">
                <div className="captcha-container">
                  <label>Captcha*</label>
                  <div className="captcha-box">
                    <span className="captcha-text">{captcha}</span>
                    <IoReloadCircle
                      className="reload-icon"
                      onClick={generateCaptcha}
                    />
                  </div>
                </div>

                <div className="captcha-input">
                  <label>Enter Captcha*</label>
                  <input
                    type="text"
                    name="captchaInput"
                    placeholder="Enter Captcha"
                    required
                    value={formData.captchaInput}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <button type="submit" className="git-submit" disabled={loading}>
                {loading ? "Sending..." : "Send Message"}
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default GetInTouch;